import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'var(--brand-off-white)', textAlign: 'center', padding: '2rem' }}>
      <div style={{ fontFamily: 'var(--font-display)', fontSize: '6rem', fontWeight: 700, color: 'var(--gray-200)', lineHeight: 1 }}>404</div>
      <h1 style={{ fontFamily: 'var(--font-display)', marginTop: '0.5rem', marginBottom: '0.5rem' }}>Page not found</h1>
      <p style={{ color: 'var(--gray-500)', marginBottom: '1.5rem' }}>The page you're looking for doesn't exist.</p>
      <Link to="/dashboard" className="btn btn-primary">Go to Dashboard</Link>
    </div>
  );
}